import { AxiosInstance } from 'axios';

const path = '/azure';

export default function authWithAzure(api: AxiosInstance) {
  return (redirect: string) => api.getUri({ url: path, params: { redirect } });
}
